import React from "react";

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
}

const CalendarIcon: React.FC<IconProps> = ({
  width = 25,
  height = 25,
  color = "rgb(69, 110, 141)",
  onClick = () => {}
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C20.1752 21.4816 19.3001 21.7706 18 21.8985"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M7 4V2.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17 4V2.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M21.5 9H16.625H10.75M2 9H5.875"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="17" cy="17" r="1" fill={color} />
      <circle cx="17" cy="13" r="1" fill={color} />
      <circle cx="12" cy="17" r="1" fill={color} />
      <circle cx="12" cy="13" r="1" fill={color} />
      <circle cx="7" cy="17" r="1" fill={color} />
      <circle cx="7" cy="13" r="1" fill={color} />
    </svg>
  );
};

export default CalendarIcon;
